// Fix this file, do not use any as the type
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { matchPath } from 'react-router-dom'

const queryUsable = (valueToCheck: any): any =>
  valueToCheck === 0 || valueToCheck === false || valueToCheck

const removeObjFromArray = (qs: any, query: any): any =>
  Object.keys(qs).reduce((obj: any, key: any) => {
    if (!query.includes(key)) {
      obj[key] = qs[key]
    }
    return obj
  }, {})

export const getCleanQueryObj = (data: any): any =>
  Object.keys(data).reduce((obj: any, key: any) => {
    if (queryUsable(data[key])) return { ...obj, [key]: data[key] }
    return { ...obj }
  }, {})

export const queryObjToString = (data: any): any => {
  const cleanObj = getCleanQueryObj(data)
  const listParams = Object.keys(cleanObj).map((key: any) => {
    if (Array.isArray(cleanObj[key])) return `${key}=${cleanObj[key].toString()}`
    return `${key}=${encodeURIComponent(cleanObj[key])}`
  })
  if (listParams.length) return `?${listParams.join('&')}`
  return ''
}

export const queryStringToObj = (url: any): any => Object.fromEntries(new URLSearchParams(url))

export const mergeQueryObjAndString = (qsObj: any, qsString: any): any => {
  const newQs = queryStringToObj(qsString)
  return queryObjToString({
    ...qsObj,
    ...newQs,
  })
}

export const queryParamsURL = {
  get(): any {
    const qs = window.location.search
    return queryStringToObj(qs)
  },
  getURL(): any {
    return window.location.pathname
  },
  getParams(path: any): any {
    const pathname = this.getURL()
    return matchPath(pathname, { path })?.params || {}
  },
  set(queryObjOrFunc: any): any {
    const qs = this.get()
    let newQueryString

    if (typeof queryObjOrFunc === 'function') {
      const queryObj = queryObjOrFunc(qs)
      newQueryString = queryObjToString(queryObj)
    } else {
      newQueryString = queryObjToString({ ...qs, ...queryObjOrFunc })
    }

    window.history.replaceState(this.get(), '', newQueryString)
    return queryStringToObj(newQueryString)
  },
  remove(queryArray: any): any {
    const qs = this.get()
    const queryObj = removeObjFromArray(qs, queryArray)

    window.history.replaceState(this.get(), '', queryObjToString(queryObj))
  },
}

export const serializeQueryToURL = (newQuery: any): any => {
  const query = queryParamsURL.set(newQuery)

  const emptyQuery: any = []

  Object.entries(query).forEach(([key, value]) => {
    if (!queryUsable(value)) {
      emptyQuery.push(key)
    }
  })

  if (emptyQuery.length) {
    queryParamsURL.remove(emptyQuery)
  }

  return queryStringToObj(query)
}
